import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

export const useV2ShourumFlatData = () =>
  useMutation(
    async (data: {
      flats?: Partial<{
        callCenterPhone: string | null;
        employeePhone: string | null;
        employee: string | null;
        callCenterAddress: string | null;
        buildingAddress: string | null;
        buildingName: string | null;
        entranceName: string | null;
        floor: number | null;
        flatNumber: string | null;
        currency: string | null;
        flatRooms: number | null;
        houseName: string | null;
        clientSaleAmount: number | null;
        clientMonthlyPayment: number | null;
        clientPerAreaPrice: number | null;
        clientPrepayment: number | null;
        clientDiscountPercent: number | null;
        clientDiscountAmount: number | null;
        offerText: string | null;
        images: string[] | null;
        flatFloorImage: string | null;
        flatTableList: {
          prepayment: number | null;
          prepaymentPercent: number | null;
          discount: number | null;
          discountPercent: number | null;
          saleAmount: number | null;
          delay: number | null;
          monthlyPayment: number | null;
        }[];
      }>[];
      lang: string | null;
      hexColor: string | null;
      cellHexColor: string | null;
      companyLogo: string | null;
      facebookUrl: string | null;
      instagramUrl: string | null;
      telegramUrl: string | null;
      webSiteUrl: string | null;
      print?: boolean;
      houseName?: string | null;
    }) => {
      delete data?.print;

      const res = await $api.post('/v2/shourum/flat-data', data, { responseType: 'blob' });

      return res.data;
    }
  );
